export const AUTH_USER = 'AUTH_USER';